import { render, staticRenderFns } from "./flightItem.vue?vue&type=template&id=fe7728a0&scoped=true"
import script from "./flightItem.vue?vue&type=script&lang=js"
export * from "./flightItem.vue?vue&type=script&lang=js"
import style0 from "./flightItem.vue?vue&type=style&index=0&id=fe7728a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7728a0",
  null
  
)

export default component.exports